/* eslint-disable jira/filename-case */
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import Modal from '@atlaskit/modal-dialog/modal-dialog';
import type { ModalDialogProps } from '@atlaskit/modal-dialog/types';
import type { ChoreographedComponentProps } from '@atlassian/jira-choreographer-services/src/types.tsx';
import { withChoreographedRender } from '@atlassian/jira-choreographer-services/src/withChoreographedRender.tsx';

export const ChoreographerModal: {
	(props: ModalDialogProps & ChoreographedComponentProps): React.JSX.Element;
	displayName: string;
} = withChoreographedRender<ModalDialogProps>(Modal);
